import { useNavigate } from "react-router-dom";
import { axiosPrivate } from "./axiosPrivate";

export default class PrivateApi {

    navigate = useNavigate();
    
    // Profile
    get_UserLogged = async() => {
        return await axiosPrivate.get('/qr_backend/partner/logged/');
    }
    post_UserUpdate = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/update/', data);
    }
    changePassword_Partner = async(post_data) => {
        return await axiosPrivate.post('/qr_backend/partner/update/password/', post_data);
    }
    post_PartnerImage = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/update/image/', data);
    }
    post_PartnerLoginDataChange = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/update/login/', data);
    }
    post_Partner_document_preference_save = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/document/preference/save/', data);
    }
    get_Account_switch = async(accountId) => {
        return await axiosPrivate.get(`/qr_backend/account/switch/${accountId}/`);
    }
    get_Vollmacht_data = async(token) => {
        return await axiosPrivate.get(`/qr_backend/vollmacht/new/${token}/`);
    }
    post_Vollmacht_save = async(data) => {
        return await axiosPrivate.post('/qr_backend/vollmacht/new/save/', data);
    }
    

    // ElvPage
    get_ElvsAll = async() => {
        return await axiosPrivate.get('/qr_backend/elvs/');
    }
    get_ElvsBuilding = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/elvs/building/${building_id}/`);
    }


    // ElvDetailPage
    get_ElvsDetail = async(elv_id) => {
        const result = await axiosPrivate.get(`/qr_backend/elvs/${elv_id}/`);
        return result.data;
    }
    post_ElvsTeilvorschrebungsEdit = async(data) => {
        return await axiosPrivate.post('/qr_backend/elvs/teilbvorschreibung/', data);
    }
    post_Abrechnung_missing = async(data) => {
        return await axiosPrivate.post('/qr_backend/abrechnung/missing/', data);
    }

    // HvAnlageCard
    get_ElvsAnlage = async(anlage_id) => {
        return await axiosPrivate.get(`/qr_backend/elvs/anlage/${anlage_id}/`);
    }

    

    // DownloadPage
    get_InvoicesUser = async() => {
        return await axiosPrivate.get('/qr_backend/invoices/user/');
    }
    get_InvoicesPrivateUser = async() => {
        return await axiosPrivate.get('/qr_backend/private/invoices/user/');
    }
    get_InvoiceSingleDownload = async(invoice) => {
        return await axiosPrivate.get(`/qr_backend/invoice/download/single/${invoice}/`)
    }
    get_InvoiceSinglePreview = async(invoice) => {
        return await axiosPrivate.get(`/qr_backend/invoice/download/single/${invoice}/preview/`)
    }
    post_InvoiceDownload = async(invoice_list) => {
        return await axiosPrivate.post('/qr_backend/invoice/download/', invoice_list);
    }
    post_InvoicePrepare = async(invoice_list) => {
        return await axiosPrivate.post('/qr_backend/invoice/zip/prepare/', invoice_list);
    }
    post_InvoiceDownloadZip = async(data) => {
        return await axiosPrivate.get(`/qr_backend/invoice/zip/download/${data}/`,  { responseType: 'blob' });
    }
    post_Invoices_prepare = async(data) => {
        return await axiosPrivate.post('/qr_backend/invoices/download/prepare/', data);
    }
    post_Invoices_prepare_check = async(data) => {
        return await axiosPrivate.post('/qr_backend/invoices/download/prepare/check/', data);
    }
    post_Invoices_prepare_zip = async(data) => {
        return await axiosPrivate.post('/qr_backend/invoices/download/zip/', data);
    }



    // SupportPage
    get_Ticket = async() => {
        const result = await axiosPrivate.get('/qr_backend/ticket/');
        return result.data;
    }
    get_Ticket_close = async(ticket_id) => {
        return await axiosPrivate.get(`/qr_backend/ticket/close/${ticket_id}/`);
    }
    post_Ticket_close = async(data) => {
        return await axiosPrivate.post('/qr_backend/ticket/close/', data);
    }
    post_Ticket= async(data) => {
        return await axiosPrivate.post('/qr_backend/ticket/new/', data);
    }
    post_Ticket_hw = async(data) => {
        return await axiosPrivate.post('/qr_backend/ticket/hw/new/', data);
    }
    get_TicketDetails = async(ticket_id) => {
        return await axiosPrivate.get(`/qr_backend/ticket/${ticket_id}/`);
    }
    post_TicketMessage = async(data) => {
        return await axiosPrivate.post('/qr_backend/ticket/message/', data);
    }
    get_Anlagen = async() => {
        return await axiosPrivate.get('/qr_backend/anlagen/');
    }
    get_Anlagen_all = async() => {
        var result = await axiosPrivate.get('/qr_backend/anlagen/all/');
        return result.data;
    }
    get_Poolrechnung_by_rechnungsnummer = async(rechnungsnummer) => {
        return await axiosPrivate.get(`/qr_backend/poolrechnung/rechnungsnummer/${rechnungsnummer}/`);
    }
    get_Partner_employees = async() => {
        return await axiosPrivate.get('/qr_backend/partner/employees/');
    }
    get_Partner_employee_archive = async(eid) => {
        return await axiosPrivate.get(`/qr_backend/partner/employees/archive/${eid}/`);
    }
    get_Abrechnung_search = async(data) => {
        return await axiosPrivate.post('/qr_backend/abrechnung/search/', data);
    }
    post_Partner_employee_save = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/employees/save/', data);
    }
    get_Invoices_by_anlage = async(anlage_id) => {
        return await axiosPrivate.get(`/qr_backend/invoices/anlage/${anlage_id}/`);
    }
    search_Invoices = async(invoiceNum) => {
        return await axiosPrivate.get(`/qr_backend/invoices/search/${invoiceNum}`);
    }

    
    // Notifications
    get_Notifications = async() => {
        const response = await axiosPrivate.get('/qr_backend/notification/');
        return response.data;
    }
    get_Notifications_detail = async(notification_id) => {
        return await axiosPrivate.get(`/qr_backend/notification/${notification_id}/`);
    }
    get_Notifications_unreaded = async() => {
        const response = await axiosPrivate.get('/qr_backend/notification/unreaded/');
        return response.data;
    }
    setRead_Notifications = async(notifications) => {
        return await axiosPrivate.put(`/qr_backend/notification/read/`, notifications);
    }
    delete_Notifications = async(notifications) => {
        return await axiosPrivate.post(`/qr_backend/notification/delete/`, notifications);
    }
    


    // Customer Dashboard
    client_dashboard = async() => {
        return await axiosPrivate.get('/qr_backend/client/dashboard');
    }

    // Customer AnlagenPage
    client_anlagen = async() => {
        return await axiosPrivate.get(`/qr_backend/client/anlagen`);
    }


    // Customer TimelinePage
    client_timeline = async() => {
        return await axiosPrivate.get('/qr_backend/client/timeline');
    }
    client_timeline_download = async(type, id) => {
        return await axiosPrivate.get(`qr_backend/client/timeline/download/${type}/${id}/`);
    }
    client_timeline_vollmacht = async() => {
        return await axiosPrivate.get('/qr_backend/partner/vollmacht/');
    }



    // HV Dashboard
    hw_Dashboard = async() => {
        const response = await axiosPrivate.get('/qr_backend/hw/dashboard/');
        return response.data;
    }
    hw_search = async(data) => {
        return await axiosPrivate.post('/qr_backend/hw/search/', data);
    }
    feedback_post = async(data) => {
        return await axiosPrivate.post('/qr_backend/feedback/new/', data);
    }
    hw_formulars_active = async() => {
        return await axiosPrivate.get('/qr_backend/formulars/active/');
    }
    hw_formular_download = async(fid, qty) => {
        return await axiosPrivate.get(`/qr_backend/formulars/download/${fid}/${qty}/`, {
            responseType: "blob",
        });
    }


    // HV Timeline for Building
    hw_building_timeline = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/hw/timeline/building/${building_id}`)
    }


    // HV LeerstandPage
    hw_TopAnlagen = async(qr) => {
        return await axiosPrivate.get(`/qr_backend/anlagen/top/qr/${qr}/`);
    }
    
    // AnlagenPage, LeerstandPage, ElvDetailPage
    hw_Anlagen = async(qr) => {
        return await axiosPrivate.get(`/qr_backend/anlagen/building/qr/${qr}/`);
    }
    hw_Anlagen_new = async(data) => {
        return await axiosPrivate.post('/qr_backend/anlagen/new/', data);
    }
    hw_Anlagen_edit = async(data) => {
        return await axiosPrivate.post('/qr_backend/anlagen/edit/', data);
    }
    hw_Anlagen_register = async(data) => {
        return await axiosPrivate.post('/qr_backend/anlagen/register/', data);
    }
    private_qr_scanned = async(qr) => {
        return await axiosPrivate.get(`/qr_backend/qr/scanned/${qr}/`);
    }
    private_Anlagen_new = async(data) => {
        return await axiosPrivate.post('/qr_backend/private/anlagen/new/', data);
    }

    // HV BuildingsPage
    hw_Buildings = async() => {
        return await axiosPrivate.get('/qr_backend/partner/buildings');
    }
    hw_BuildingsNew = async(data) => {
        return await axiosPrivate.post('/qr_backend/partner/buildings/new/', data);
    }
    hw_change = async(data) => {
        return await axiosPrivate.post('/qr_backend/building/change/', data);
    }
    hw_all = async() => {
        return await axiosPrivate.get('/qr_backend/partner/hw/all/');
    }


    // HV BuldingAnlagenPage
    get_AnlagenBuilding = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/anlagen/building/${building_id}/`);
    }
    get_Anlagen_all_info = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/building/anlagen/all/${building_id}/`);
    }
    get_Anlagen_including_now_owned = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/building/anlagen/includenotowned/${building_id}/`);
    }


    // InvoicePage
    hw_InvoicesBuilding = async(building_id) => {
        return await axiosPrivate.get(`/qr_backend/hw/invoices/building/${building_id}/`);
    }
    
    
    // LeerstandPage, ElvDetailPage
    hw_AnlagenSetLeerstand = async(anlagen) => {
        return await axiosPrivate.post(`/qr_backend/hw/anlagen/leerstand`, anlagen);
    }

    // ArchivePage
    get_Archive = async() => {
        const result = await axiosPrivate.get('/qr_backend/archive/');
        return result.data;
    }
    get_ArchiveDownload = async(name) => {
        return await axiosPrivate.get(`/qr_backend/archive/${name}/`);
    }


    // FaqPage
    get_faq = async(target) => {
        return await axiosPrivate.get(`/qr_backend/faq/${target}/`);
    }
    search_faq = async(data) => {
        return await axiosPrivate.post('/qr_backend/faq/search/');
    }




    logout = () => {
        this.navigate("/logout");
    }

    checkIsLoggedIn = async() => {
        if (localStorage.getItem('token') !== null) {
            return await axiosPrivate.get("/qr_backend/login/check/");
        }
    }

    get_Tooltips = async() => {
        return await axiosPrivate.get('/qr_backend/tooltips/');
    }
}